<template>
  <div class="processes-view">
    <div v-if="company">
      <div style="margin-bottom: 50px">
        <SidebarToggleView />
        <span class="display-2">Verfahren | {{ company.name }}</span>
        <span style="float: right">
          <v-btn outlined color="primary" v-on:click="onCreateNew()">
            Verfahren Hinzufügen
          </v-btn>
        </span>
        <span
          v-if="!company.processes.items.length"
          style="float: right"
          class="mr-2"
          color="primary"
          @click="onCreateFromTemplate"
        >
          <v-btn outlined color="primary">
            <v-icon class="mr-2">post_add</v-icon>VVT-Vorlage importieren
          </v-btn>
        </span>
      </div>
      <v-toolbar outlined>
        <v-toolbar-items>
          <v-btn
            text
            :class="sort_var == 'seq_nr' ? 'primary--text' : ''"
            v-on:click="sortProcesses('seq_nr')"
            >Nr.
            <v-icon v-if="sort_var == 'seq_nr'" small>{{
              sort_order == "ASC" ? "arrow_downward" : "arrow_upward"
            }}</v-icon>
          </v-btn>
          <v-btn
            text
            :class="sort_var == 'text_header' ? 'primary--text' : ''"
            v-on:click="sortProcesses('text_header')"
          >
            Name
            <v-icon v-if="sort_var == 'text_header'" small>{{
              sort_order == "ASC" ? "arrow_downward" : "arrow_upward"
            }}</v-icon>
          </v-btn>
          <v-btn
            text
            :class="sort_var == 'updatedAt' ? 'primary--text' : ''"
            v-on:click="sortProcesses('updatedAt')"
            >Datum
            <v-icon v-if="sort_var == 'updatedAt'" small>{{
              sort_order == "ASC" ? "arrow_downward" : "arrow_upward"
            }}</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-text-field
          hide-details
          class="ml-2"
          v-model="search"
          placeholder="Suche in Verfahren"
          append-icon="search"
          @click:append="() => (openSearch = !openSearch)"
        >
        </v-text-field>
        <v-menu :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="showArchived" color="primary"></v-switch>
                </v-list-item-action>
                <v-list-item-title
                  >Archivierte Verfahren anzeigen</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click="prepareCopyDialog">
                <v-list-item-title
                  >Bestehendes Verfahren kopieren</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar>

      <v-row>
        <v-col>
          <v-card>
            <v-list two-line>
              <template v-for="(process, index) in company.processes.items">
                <v-list-item
                  v-if="!process.archived_at || showArchived"
                  @click="onClick(process)"
                  :class="process.archived_at ? 'grey--text' : ''"
                >
                  <v-list-item-avatar>
                    Nr. {{ process.seq_nr }}
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      ><span
                        v-html="highlightSearch(process.text_header)"
                      ></span>
                      <v-tooltip v-if="process.assessment_necessary" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="primary" dark v-bind="attrs" v-on="on"
                            >mdi-alert-octagon</v-icon
                          >
                        </template>
                        <span>DSFA notwendig</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >{{ process.updatedAt | moment("llll") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <!--to show search results if available-->
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-lg-right"
                      two-line
                      v-html="getMatchingPart(process)"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action
                    v-if="process.archived_at"
                    @click.stop="unarchiveProcess(process)"
                  >
                    <v-hover>
                      <v-icon
                        slot-scope="{ hover }"
                        :color="`primary lighten-${hover ? 2 : 0}`"
                        >unarchive
                      </v-icon>
                    </v-hover>
                  </v-list-item-action>
                  <v-list-item-action
                    v-if="!process.archived_at"
                    @click.stop="archiveProcess(process)"
                  >
                    <v-hover>
                      <v-icon
                        slot-scope="{ hover }"
                        :color="hover ? 'error' : 'grey'"
                        >archive
                      </v-icon>
                    </v-hover>
                  </v-list-item-action>
                  <v-list-item-action>
                    <span
                      ><v-icon
                        small
                        style="float: left"
                        :color="
                          process.status == 'DOCUMENTED' ||
                          process.status == 'PLANNED' ||
                          process.status == 'COMPLETED'
                            ? 'info'
                            : 'grey lighten-2'
                        "
                        >brightness_1</v-icon
                      >
                    </span>
                    <span
                      ><v-icon
                        small
                        style="float: left"
                        :color="
                          process.status == 'PLANNED' ||
                          process.status == 'COMPLETED'
                            ? 'info'
                            : 'grey lighten-2'
                        "
                        >brightness_1</v-icon
                      >
                    </span>
                    <span
                      ><v-icon
                        small
                        style="float: left"
                        :color="
                          process.status == 'COMPLETED'
                            ? 'info'
                            : 'grey lighten-2'
                        "
                        >brightness_1</v-icon
                      >
                    </span>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!--BEGIN dialogs section-->
    <!-- Dialog for confirming archive process-->
    <v-dialog v-model="archiveDialog" max-width="350">
      <v-card>
        <v-card-title class="headline">Verfahren archivieren</v-card-title>

        <v-card-text>
          Sind Sie sicher, dass Sie dieses Verfahren archivieren möchten?
        </v-card-text>
        <v-card-text>
          Archivierte Verfahren können über die option
          <i>Archivierte Verfahren anzeigen</i> jederzeit dargestellt und bei
          Bedarf aus dem Archiv wiederhergestellt werden, tauchen jedoch nicht
          im ausgedruckten Verfahrensverzeichnis auf. Die eindeutige Nummer des
          Verfahrens bleibt erhalten. Die Archivierung ist revisionssicher.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" outlined @click.stop="archiveDialog = false">
            Nein
          </v-btn>

          <v-btn
            color="error"
            outlined
            @click.stop="archiveProcess(null, true)"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog for confirming unarchive process-->
    <v-dialog v-model="unArchiveDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Verfahren dearchivieren</v-card-title>

        <v-card-text>
          Sind Sie sicher, dass Sie dieses Verfahren aus dem Archiv
          wiederherstellen möchten?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" outlined @click.stop="unArchiveDialog = false">
            Nein
          </v-btn>

          <v-btn
            color="warning"
            outlined
            @click.stop="unarchiveProcess(null, true)"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Copy process selection dialog-->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="1000px"
      class="text-center"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Bestehendes Verfahren kopieren</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm12>
                <v-select
                  :items="copyDialogCompanies"
                  label="Unternehmen"
                  item-text="name"
                  item-value="id"
                  v-model="copyDialogCompany"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm12 v-if="copyDialogCompany">
                <v-select
                  :items="copyDialogProcesses"
                  item-value="id"
                  label="Verfahren"
                  v-model="copyDialogProcess"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
          <!--<small>*indicates required field</small>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Abbrechen</v-btn
          >
          <v-btn color="blue darken-1" text @click="copyProcess"
            >Kopie erstellen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="company">
      <ProcessCreateView
        :showThis="show_process_create_view"
        :company_id="company.id"
        :num_procs="company.processes.items.length"
        :max_procs="max_processes"
        v-on:discard="show_process_create_view = false"
      >
      </ProcessCreateView>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ProcessCreateView from "./ProcessCreateView";
import SidebarToggleView from "./SidebarToggleView";

import XLSX from "xlsx";

const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

String.prototype.format = function () {
  return [...arguments].reduce((p, c) => p.replace(/%s/, c), this);
};
import {
  createProcessMeasure,
  createProcessMeasureSet,
  updateProcess,
} from "../graphql/mutations";

const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    processes(limit:500, nextToken: %s) {
        items {
            id
            text_header
            text_problem
            text_legal
            legal_basis
            damage_scenario
            risk_probability
            data_category
            victim_risk
            damage_rate
            dept_resp
            recipient_category
            delete_period
            seq_nr
            status
            updatedAt
            archived_at
            assessment_necessary
        }
        nextToken
    }
  }
}
`;

const sortByASC = function (arr, prop, cIns) {
  if (cIns) {
    return arr.sort((a, b) =>
      String(a[prop]).toLowerCase() < String(b[prop]).toLowerCase()
        ? -1
        : String(a[prop]).toLowerCase() > String(b[prop]).toLowerCase()
        ? 1
        : 0
    );
  }
  return arr.sort((a, b) =>
    a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0
  );
};
const sortByDESC = function (arr, prop, cIns) {
  if (cIns) {
    return arr.sort((a, b) =>
      String(a[prop]).toLowerCase() < String(b[prop]).toLowerCase()
        ? 1
        : String(a[prop]).toLowerCase() > String(b[prop]).toLowerCase()
        ? -1
        : 0
    );
  }

  return arr.sort((a, b) =>
    a[prop] < b[prop] ? 1 : a[prop] > b[prop] ? -1 : 0
  );
};

const sortBy = function (arr, prop, how, cIns) {
  return how == "ASC"
    ? sortByASC(arr, prop, cIns)
    : sortByDESC(arr, prop, cIns);
};

const TEXT_FIELDS = ["text_problem", "text_legal", "text_risk_victim"];
// define the HINT lengths
const HINT_LENGTH = 20;
// max length of chars before hint starts
const HINT_BEFORE = 10;
// max length of chars after hint ends
const HINT_AFTER = 50;
// Note: can't use import syntax for this because the module
// does not export anything, nor declares any global vars in main file
let JsSearch = require("js-search");

import { createProcess } from "../graphql/mutations";
import ImportView from "./ImportView";

export default {
  components: {
    ProcessCreateView,
    SidebarToggleView,
  },
  name: "ProcessesView",
  props: {
    msg: String,
  },
  watch: {
    search: {
      handler(val) {
        return this.searchHandler(val);
      },
      sort_var: {
        handler(val) {},
      },
    },
  },
  computed: {
    max_seq_nr: {
      get() {
        return this.$store.state.originalStore.max_seq_nr;
      },
      set(value) {
        this.$store.commit("SET_max_seq_nr", value);
      },
    },
    copyDialogCompanies() {
      return this.$store.state.copyProcesses.companies;
    },
    copyDialogCompany: {
      get() {
        return this.$store.state.copyProcesses.currentCompany;
      },
      set(value) {
        this.$store.commit("SET_SELECTED_COMPANY", { currentCompanyId: value });
        if (value) {
          this.$store.dispatch("getProcessesForCompanies");
        }
      },
    },
    copyDialogProcessesCount() {
      return this.$store.state.copyProcesses.companyProcesses.length;
    },
    copyDialogProcesses() {
      return this.$store.state.copyProcesses.companyProcesses
        .filter((item) => !item.archived_at)
        .sort((a, b) => {
          return a.seq_nr - b.seq_nr;
        })
        .map((item) => ({
          ...item,
          text: "Nr. " + item.seq_nr + " - " + item.text_header,
        }));
    },
    copyDialogProcess: {
      get() {
        return this.$store.state.copyProcesses.currentProcess;
      },
      set(value) {
        this.$store.commit("SET_CURRENT_PROCESS", { currentProcess: value });
      },
    },
    activeCompany() {
      return this.$store.state.originalStore.activeCompany;
    },
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
    max_processes() {
      if (!this.user_info) {
        return null;
      }
      var product_id = this.user_info.attributes["custom:active_product_id"];
      return products[product_id].usage.max_processes;
    },
  },
  mounted() {
    this.getContent(this.$route.params.id);
    this.searcher.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();
    // add the field on which to search
    this.searcher.addIndex("text_header");
    this.searcher.addIndex("text_problem");
    this.searcher.addIndex("text_legal");
    this.searcher.addIndex("text_risk_victim");
  },
  methods: {
    onGoToImport() {
      this.importDialog = true;
    },
    onClick(item) {
      this.$router.push({ path: `process/${item.id}` });
    },
    can_create_process() {
      var num_processes = Math.max(
        this.processesCache.length,
        this.company.processes.items.length
      );
      return num_processes < this.max_processes;
    },
    onCreateNew() {
      if (this.can_create_process()) {
        //this.$router.push({path: `process/new`});
        this.show_process_create_view = true;
      } else {
        var num_processes = Math.max(
          this.processesCache.length,
          this.company.processes.items.length
        );
        this.$eventHub.emit("show-process-create-disallowed", num_processes);
      }
    },
    getContent(company_id, nextToken) {
      return this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(
          getCompany.format(nextToken ? '"' + nextToken + '"' : null),
          { id: company_id }
        )
      ).then((res) => {
        if (this.company == null) {
          this.company = res.data.getCompany;
        } else {
          this.company.processes.items.push(
            ...res.data.getCompany.processes.items
          );
        }
        // add the search items
        this.searcher.addDocuments(res.data.getCompany.processes.items);
        this.max_seq_nr = Math.max(
          0,
          ...this.company.processes.items.map((process) => process.seq_nr)
        ); // store the maximum sequence number for this company (to be used for a new process)

        if (this.sort_var === "seq_nr") {
          sortBy(this.company.processes.items, this.sort_var, this.sort_order);
        } else {
          sortBy(
            this.company.processes.items,
            this.sort_var,
            this.sort_order,
            true
          );
        }
        var procsNextToken = res.data.getCompany.processes.nextToken;
        if (procsNextToken !== null) {
          this.getContent(company_id, procsNextToken);
        }
      });
    },
    highlightSearch(text) {
      if (!this.search) {
        return text;
      }
      let retVal = text.replace(new RegExp(this.search, "gi"), (match) => {
        return '<span style="background:#f5ea4c">' + match + "</span>";
      });

      return retVal;
    },
    getMatchingPart(obj) {
      if (!this.search) {
        return "";
      }

      let matVal = null;
      let keys = TEXT_FIELDS;
      for (let i = 0; i < keys.length; i++) {
        let curKey = keys[i];
        let curVal = obj[curKey];
        let match = new RegExp(this.search, "i").exec(curVal);
        if (match == null) {
          continue;
        }

        // find the begin and end index
        let begin = Math.max(
          0,
          match.index - (HINT_LENGTH - this.search.length) - HINT_BEFORE
        );
        let end = Math.min(
          begin + HINT_BEFORE + HINT_LENGTH + HINT_AFTER,
          curVal.length - 1
        );
        let originalLength = curVal.length;
        curVal = curVal.substring(begin, end);

        // trim the uncompleted texts from begin and end
        curVal = curVal.substring(curVal.indexOf(" "), curVal.lastIndexOf(" "));
        matVal = curVal.replace(new RegExp(this.search, "i"), (mat) => {
          return '<span style="background:#f5ea4c">' + mat + "</span>";
        });

        if (matVal !== curVal) {
          break;
        }
      }

      return matVal;
    },
    sortProcesses(field) {
      if (this.sort_var == field) {
        // change the sort order
        this.sort_order = this.sort_order == "ASC" ? "DESC" : "ASC";
      } else {
        this.sort_var = field;
        this.sort_order = "ASC";
      }
      if (this.sort_var === "seq_nr") {
        sortBy(this.company.processes.items, this.sort_var, this.sort_order);
      } else {
        var self = this;
        sortBy(
          this.company.processes.items,
          this.sort_var,
          this.sort_order,
          true
        );
      }
    },
    archiveProcess(process, confirm) {
      if (confirm) {
        // TODO code to archive the process
        var self = this;
        this.processToArchive.archived_at = new Date().toISOString();
        this.$Amplify.API.graphql(
          this.$Amplify.graphqlOperation(updateProcess, {
            input: this.processToArchive,
          })
        ).then((response) => {
          // dismiss the confirmation dialog
          self.archiveDialog = false;
          // set the processToArchive to null as its been archived
          self.processToArchive = null;
        });
      } else {
        if (!process) {
          return false;
        }
        this.processToArchive = process;
        // show confirmation dialog
        this.archiveDialog = true;
      }
      return false;
    },
    unarchiveProcess(process, confirm) {
      if (confirm) {
        // TODO code to unarchive the process
        var self = this;
        this.processToUnarchive.archived_at = null;
        this.$Amplify.API.graphql(
          this.$Amplify.graphqlOperation(updateProcess, {
            input: this.processToUnarchive,
          })
        ).then((response) => {
          // dismiss the confirmation dialog
          self.unArchiveDialog = false;
          // set the processToArchive to null as its been archived
          self.processToUnarchive = null;
        });
      } else {
        if (!process) {
          return false;
        }
        this.processToUnarchive = process;
        // show confirmation dialog
        this.unArchiveDialog = true;
      }
      return false;
    },
    updateProcessMutation(process) {
      return this.$Amplify.graphqlOperation(updateProcess, { input: process });
    },
    searchHandler(val) {
      if (this.company) {
        if (val.length > 0) {
          this.$store.commit("SET_search_company", {
            companyId: this.company.id,
            search: val,
          });
          // take backup of original company processes
          // this if statement makes sure that we retain the original number of processes
          // and not filtered ones
          if (
            this.processesCache.length < this.company.processes.items.length
          ) {
            // clone the array(instead of assigning it)
            this.processesCache = this.company.processes.items.slice(0);
          }
          this.company.processes.items = this.searcher.search(val);
          this.sort_var = "";
          this.sort_order = "ASC";
        } else {
          // restore the original number of process items
          this.company.processes.items = this.processesCache;
          this.$store.commit("SET_search_company", {
            companyId: this.company.id,
            search: "",
          });
        }
      }
    },
    prepareCopyDialog() {
      // fetch the companies
      this.$store.dispatch("getCompanies").then(() => {
        this.dialog = true;
      });
    },
    async copyProcess() {
      var self = this;
      let selectedProcess = this.copyDialogProcesses.filter(
        (item) => item.id === self.copyDialogProcess
      )[0];

      // destructuring the process object to match graphql schema definition
      let processCache = (({
        text_header,
        seq_nr,
        status,
        text_legal,
        legal_basis,
        text_problem,
        damage_scenario,
        risk_probability,
        data_category,
        victim_risk,
        damage_rate,
        dept_resp,
        recipient_category,
        delete_period,
      }) => ({
        text_header,
        seq_nr,
        status,
        text_legal,
        legal_basis,
        text_problem,
        damage_scenario,
        risk_probability,
        data_category,
        victim_risk,
        damage_rate,
        dept_resp,
        recipient_category,
        delete_period,
      }))(selectedProcess);

      // override fields
      processCache.text_header = "Kopie von " + processCache.text_header;

      // manage additional fields
      processCache.seq_nr = this.max_seq_nr + 1;
      processCache.processCompanyId = this.company.id;
      processCache.id = null;
      try {
        let resp = await this.$Amplify.API.graphql(
          this.$Amplify.graphqlOperation(createProcess, { input: processCache })
        );
        let createdProcess = resp.data.createProcess;

        // copy the process measures
        let processMeasures = selectedProcess.measures.items;
        for (let i = 0; i < processMeasures.length; i++) {
          let curProcessMeasure = processMeasures[i];
          resp = await this.$Amplify.API.graphql(
            this.$Amplify.graphqlOperation(createProcessMeasure, {
              input: {
                label: curProcessMeasure.label,
                description: curProcessMeasure.description,
                status: curProcessMeasure.status,
                processMeasureProcessId: createdProcess.id,
              },
            })
          );
        }

        // now create link to measure sets if process is from same company
        if (this.copyDialogCompany.id === this.company.id) {
          // copy processMeasureSets too
          let processMeasureSets = selectedProcess.measureSets.items;
          // create processMeasure set linkages
          for (let i = 0; i < processMeasureSets.length; i++) {
            let curProcessMeasureSet = processMeasureSets[i];
            resp = await this.$Amplify.API.graphql(
              this.$Amplify.graphqlOperation(createProcessMeasureSet, {
                input: {
                  processMeasureSetProcessId: createdProcess.id,
                  processMeasureSetMeasureSetId:
                    curProcessMeasureSet.measureSet.id,
                  status: curProcessMeasureSet.status,
                },
              })
            );
            this.$eventHub.emit("show-notification", {
              notification: `Kopie von Verfahren ${selectedProcess.text_header} erstellt.`,
            });
          }
        } else {
          // show warning that this could not be done
          this.$eventHub.emit("show-notification", {
            notification: `Kopie von Verfahren ${selectedProcess.text_header} (ohne Verweise auf allgemeine TOMs) erstellt.`,
          });
        }
        this.searcher = new JsSearch.Search("id");
        resetSearch(this);
        let companyId = this.company.id;

        // set company to null for force refreshing process list.
        this.company = null;
        // even though we do redirect to the process vue of copied process, we must do this to refresh the max_seq_nr
        this.getContent(companyId, null);

        // redirect to the process view of copied process
        this.$router.push({ path: `process/${createdProcess.id}` });
      } catch (e) {
        this.$eventHub.emit("show-notification", {
          notification: `Fehler: Kopieren von Verfahren ${selectedProcess.text_header} fehlgeschlagen:\n ${e}. \nBitte wende Dich an den Support.`,
        });
      }
      this.copyDialogProcess = null;
      this.copyDialogCompany = null;
      this.dialog = false;
    },
    importSuccessHandler() {
      this.searcher = new JsSearch.Search("id");
      var self = this;
      this.company = null;
      this.getContent(this.$route.params.id).then((res) => {
        resetSearch(self);
      });
      this.importDialog = false;
    },
    importCancelHandler() {
      this.importDialog = false;
    },
    onCreateFromTemplate() {
      this.$router.push({
        path: "/app/company/" + this.$route.params.id + "/template/",
      });
    },
  },
  data: () => ({
    company: null,
    response: null,
    sort_var: "seq_nr",
    sort_order: "ASC",
    processesCache: [],
    search: "",
    searcher: new JsSearch.Search("id"),
    archiveDialog: false,
    processToArchive: null,
    showArchived: false,
    unArchiveDialog: false,
    processToUnarchive: null,
    dialog: false,
    importDialog: false,
    show_process_create_view: false,
  }),
  beforeRouteUpdate(to, from, next) {
    var self = this;
    let oldCompany = this.company;
    this.company = null;
    this.processesCache = [];
    let oldSearch = this.search;
    this.$store.commit("SET_search_company", {
      companyId: oldCompany.id,
      search: oldSearch,
    });
    this.search = this.$store.state.searches[to.params.id] || "";
    this.sort_var = "seq_nr";
    this.sort_order = "ASC";
    this.searcher = new JsSearch.Search("id");
    this.getContent(to.params.id).then((res) => {
      resetSearch(self);
      next();
    });
  },
};

function resetSearch(context) {
  // add the field on which to search
  context.searcher.addIndex("text_header");
  context.searcher.addIndex("text_problem");
  context.searcher.addIndex("text_legal");
  if (context.search) {
    context.searchHandler(context.search);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.active-btn {
  background: red;
}
.search-text {
  background: green;
}
</style>
